import { render, staticRenderFns } from "./Question10.vue?vue&type=template&id=5568d488&scoped=true&"
import script from "./Question10.vue?vue&type=script&lang=js&"
export * from "./Question10.vue?vue&type=script&lang=js&"
import style0 from "./Question10.vue?vue&type=style&index=0&id=5568d488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568d488",
  null
  
)

export default component.exports